'use strict';
var fileName = location.href.split("/").slice(-1);
let news = document.querySelectorAll(".topheader__button");
if (news) {
  news.forEach(el => {
    if (el.href.split("/").slice(-1)[0] == fileName[0]) el.classList.add("active");
  });
}

const navUL = document.querySelector(".topheader__navlist");
let burger = document.querySelector('.burger');
if(burger) {
  burger.addEventListener('click', (e) => {
      navUL.classList.toggle("show");
      burger.classList.toggle("show");
  });
}

const footer = document.querySelector(".footer__link");
if (footer) {
    let now = new Date();
    let year = now.getFullYear();
    footer.innerHTML += year;
}

let articles = document.querySelectorAll(".clipping");
for (let i = 0; i<articles.length; i++) {
    articles[i].addEventListener('click', (e) => {
        let target = articles[i].getAttribute("data-url");
        window.location.assign(target);
    });
}

let button = document.querySelector('.research__open');
if (button != null) {
    button.addEventListener('click', (e) => {
        e.preventDefault();
        let list = document.querySelector('.research__form');
        list.classList.toggle('hidden');
    });
}

var field = document.querySelector('[name="username"]');
if (field) {
  field.addEventListener('keyup', function ( event ) {  
    var userName = field.value;
    userName = userName.replace(/\s/g, '');
    field.value = userName;
  });
}

let myInput = document.querySelector("#password");
let letter = document.getElementById("letter");
let capital = document.getElementById("capital");
let number = document.getElementById("number");
let length = document.getElementById("length");

if(myInput) {
  // When the user clicks on the password field, show the message box
  myInput.onfocus = function() {
    document.querySelector(".login__msg").classList.add("show");
  }

  // When the user clicks outside of the password field, hide the message box
  myInput.onblur = function() {
    document.querySelector(".login__msg").classList.remove("show");
  }

  // When the user starts to type something inside the password field
  myInput.onkeyup = function() {
    // Validate lowercase letters
    let lowerCaseLetters = /[a-z]/g;
    if(myInput.value.match(lowerCaseLetters)) {
      letter.classList.remove("invalid");
      letter.classList.add("valid");
    } else {
      letter.classList.remove("valid");
      letter.classList.add("invalid");
  }

    // Validate capital letters
    let upperCaseLetters = /[A-Z]/g;
    if(myInput.value.match(upperCaseLetters)) {
      capital.classList.remove("invalid");
      capital.classList.add("valid");
    } else {
      capital.classList.remove("valid");
      capital.classList.add("invalid");
    }

    // Validate numbers
    let numbers = /[0-9]/g;
    if(myInput.value.match(numbers)) {
      number.classList.remove("invalid");
      number.classList.add("valid");
    } else {
      number.classList.remove("valid");
      number.classList.add("invalid");
    }

    // Validate length
    if(myInput.value.length >= 8) {
      length.classList.remove("invalid");
      length.classList.add("valid");
    } else {
      length.classList.remove("valid");
      length.classList.add("invalid");
    }
  }
}